import React, { useEffect, useState } from "react";
import { Input, Select } from "antd";
import "../QC/QCFilterBar.css";
import "./BatchReportsSearch.css";

export default function BatchReportsSearch(props) {
  const {
    updateSearchParameter,
    customerList,
    search: parentSearch,
    onSearch,
  } = props;
  const [searchInput, setSearchInput] = useState(parentSearch ?? "");

  // Synchronize local search input state with parent search prop.
  // If the parent search value changes and is different from the current input, update the input state to match the parent search.
  useEffect(() => {
    if (parentSearch !== searchInput) {
      setSearchInput(parentSearch ?? "");
    }
  }, [parentSearch]); // eslint-disable-line

  function updateSearch(label_value, company) {
    updateSearchParameter({ label_value, company });
  }

  function clearInput() {
    updateSearchParameter(null);
  }

  // Handles both input change and search submission.
  // If the input is cleared, it triggers an empty search.
  function handleSearchInputChange(value) {
    setSearchInput(value);
    if (value === "") {
      onSearch("");
    }
  }

  // Handles search submission when the user presses Enter or clicks the search button.
  // It trims the input value and triggers the search.
  function handleSearchSubmit(value) {
    const trimmedValue = (value ?? searchInput).trim();
    onSearch(trimmedValue);
  }

  return (
    <div className="BatchReportsSearch__Main">
      <div className="BatchReportsSearch__Field">
        <div className="batchReportFilterTitle">Filter By Company</div>
        <Select
          allowClear
          showSearch
          className="BatchReportsSearch__Select"
          popupClassName="BatchReportsSearch__Select__Menu"
          placeholder="Search Company"
          options={customerList}
          onSelect={(value, data) => updateSearch(value, data.option.company)}
          onClear={() => clearInput()}
          listHeight={320}
        />
      </div>
      <div className="BatchReportsSearch__Field">
        <div className="batchReportFilterTitle">Search by Id</div>
        <Input.Search
          allowClear
          className="QCFilterSearch BatchReportsSearch__SearchInput"
          placeholder="Search by WO, Genista ID"
          value={searchInput}
          onChange={(event) => handleSearchInputChange(event.target.value)}
          onSearch={(value) => handleSearchSubmit(value)}
        />
      </div>
    </div>
  );
}
